module.exports = __webpack_public_path__ + "media/images/webpage/hotels/staff_members/concierge_male-49771165e16c1ea3d29352ecf1e97f6d.webp";